// Airport-specific product catalog for structured data
export const airportProductCatalog = {
  gatwick: [
    {
      type: "Product",
      name: "Gatwick Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Gatwick Airport. Drop your car at the terminal and a professional chauffeur parks it securely for you. Ideal for business and family travellers.",
      brand: "Airport Parking Deals",
      sku: "GAT-MG-001",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "215",
      priceCurrency: "GBP",
      price: "89.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Gatwick with 24/7 security and CCTV. Shuttle transfers to both terminals included in the price.",
      brand: "Airport Parking Deals",
      sku: "GAT-PR-002",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "188",
      priceCurrency: "GBP",
      price: "49.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Gatwick. Drop off right outside the terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "GAT-MG-003",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "205",
      priceCurrency: "GBP",
      price: "79.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Gatwick travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "GAT-PR-004",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "170",
      priceCurrency: "GBP",
      price: "54.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "GAT-MG-005",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "162",
      priceCurrency: "GBP",
      price: "92.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "GAT-PR-006",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "198",
      priceCurrency: "GBP",
      price: "59.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included. Professional chauffeurs park your car in a premium secure zone near Gatwick terminal.",
      brand: "Airport Parking Deals",
      sku: "GAT-MG-007",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "120",
      priceCurrency: "GBP",
      price: "115.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "GAT-PR-008",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "142",
      priceCurrency: "GBP",
      price: "44.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "GAT-MG-009",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "134",
      priceCurrency: "GBP",
      price: "84.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Gatwick Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/gatwick-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips. Secure compound just 10 minutes from Gatwick terminals.",
      brand: "Airport Parking Deals",
      sku: "GAT-PR-010",
      url: "https://www.airportparkingdeals.co.uk/gatwick-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "118",
      priceCurrency: "GBP",
      price: "39.99",
      availability: "https://schema.org/InStock"
    }
  ],
  heathrow: [
    {
      type: "Product",
      name: "Heathrow Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Heathrow Airport. Drop your car at your terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "LHR-MG-001",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "231",
      priceCurrency: "GBP",
      price: "99.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Heathrow with 24/7 security. Shuttle transfers to all terminals included.",
      brand: "Airport Parking Deals",
      sku: "LHR-PR-002",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "198",
      priceCurrency: "GBP",
      price: "59.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Heathrow. Drop off right outside your terminal with fast vehicle return.",
      brand: "Airport Parking Deals",
      sku: "LHR-MG-003",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "215",
      priceCurrency: "GBP",
      price: "89.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Heathrow travellers. Great value for trips over 7 days with frequent transfers.",
      brand: "Airport Parking Deals",
      sku: "LHR-PR-004",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "180",
      priceCurrency: "GBP",
      price: "64.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Heathrow. Skip the shuttle stress.",
      brand: "Airport Parking Deals",
      sku: "LHR-MG-005",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "172",
      priceCurrency: "GBP",
      price: "102.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Heathrow. 24-hour security, ANPR gates, and full CCTV coverage.",
      brand: "Airport Parking Deals",
      sku: "LHR-PR-006",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "208",
      priceCurrency: "GBP",
      price: "69.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Heathrow. Professional chauffeurs park your car in a premium secure zone.",
      brand: "Airport Parking Deals",
      sku: "LHR-MG-007",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "130",
      priceCurrency: "GBP",
      price: "125.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Heathrow. Discounted rates for travellers who book 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "LHR-PR-008",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "152",
      priceCurrency: "GBP",
      price: "54.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Heathrow. Drop off and pick up anytime with 24/7 valet support.",
      brand: "Airport Parking Deals",
      sku: "LHR-MG-009",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "144",
      priceCurrency: "GBP",
      price: "94.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Heathrow Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/heathrow-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Heathrow. Secure compound close to all terminals.",
      brand: "Airport Parking Deals",
      sku: "LHR-PR-010",
      url: "https://www.airportparkingdeals.co.uk/heathrow-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "128",
      priceCurrency: "GBP",
      price: "49.99",
      availability: "https://schema.org/InStock"
    }
  ],
  luton: [
    {
      type: "Product",
      name: "Luton Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/luton-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Luton Airport. Drop your car at the terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "LTN-MG-001",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "195",
      priceCurrency: "GBP",
      price: "79.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/luton-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Luton with 24/7 security and CCTV. Shuttle transfers to the terminal included in the price.",
      brand: "Airport Parking Deals",
      sku: "LTN-PR-002",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "168",
      priceCurrency: "GBP",
      price: "42.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/luton-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Luton. Drop off right outside the terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "LTN-MG-003",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "185",
      priceCurrency: "GBP",
      price: "69.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/luton-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Luton travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "LTN-PR-004",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "150",
      priceCurrency: "GBP",
      price: "47.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/luton-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Luton. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "LTN-MG-005",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "142",
      priceCurrency: "GBP",
      price: "82.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/luton-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Luton. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "LTN-PR-006",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "178",
      priceCurrency: "GBP",
      price: "52.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/luton-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Luton. Professional chauffeurs park your car in a premium secure zone near the terminal.",
      brand: "Airport Parking Deals",
      sku: "LTN-MG-007",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "110",
      priceCurrency: "GBP",
      price: "105.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/luton-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Luton. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "LTN-PR-008",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "132",
      priceCurrency: "GBP",
      price: "38.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/luton-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Luton. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "LTN-MG-009",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "124",
      priceCurrency: "GBP",
      price: "74.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Luton Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/luton-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Luton. Secure compound just 10 minutes from the terminal.",
      brand: "Airport Parking Deals",
      sku: "LTN-PR-010",
      url: "https://www.airportparkingdeals.co.uk/luton-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "108",
      priceCurrency: "GBP",
      price: "35.99",
      availability: "https://schema.org/InStock"
    }
  ],
  manchester: [
    {
      type: "Product",
      name: "Manchester Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Manchester Airport. Drop your car at your terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "MAN-MG-001",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "225",
      priceCurrency: "GBP",
      price: "94.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Manchester with 24/7 security and CCTV. Shuttle transfers to all terminals included in the price.",
      brand: "Airport Parking Deals",
      sku: "MAN-PR-002",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "192",
      priceCurrency: "GBP",
      price: "54.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Manchester. Drop off right outside your terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "MAN-MG-003",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "210",
      priceCurrency: "GBP",
      price: "84.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Manchester travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "MAN-PR-004",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "175",
      priceCurrency: "GBP",
      price: "59.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Manchester. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "MAN-MG-005",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "167",
      priceCurrency: "GBP",
      price: "97.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Manchester. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "MAN-PR-006",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "202",
      priceCurrency: "GBP",
      price: "64.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Manchester. Professional chauffeurs park your car in a premium secure zone near the terminal.",
      brand: "Airport Parking Deals",
      sku: "MAN-MG-007",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "125",
      priceCurrency: "GBP",
      price: "120.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Manchester. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "MAN-PR-008",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "147",
      priceCurrency: "GBP",
      price: "49.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Manchester. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "MAN-MG-009",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "139",
      priceCurrency: "GBP",
      price: "89.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Manchester Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/manchester-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Manchester. Secure compound just 10 minutes from all terminals.",
      brand: "Airport Parking Deals",
      sku: "MAN-PR-010",
      url: "https://www.airportparkingdeals.co.uk/manchester-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "123",
      priceCurrency: "GBP",
      price: "44.99",
      availability: "https://schema.org/InStock"
    }
  ],
  birmingham: [
    {
      type: "Product",
      name: "Birmingham Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Birmingham Airport. Drop your car at the terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "BHX-MG-001",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "205",
      priceCurrency: "GBP",
      price: "84.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Birmingham with 24/7 security and CCTV. Shuttle transfers to the terminal included in the price.",
      brand: "Airport Parking Deals",
      sku: "BHX-PR-002",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "178",
      priceCurrency: "GBP",
      price: "46.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Birmingham. Drop off right outside the terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "BHX-MG-003",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "195",
      priceCurrency: "GBP",
      price: "74.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Birmingham travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "BHX-PR-004",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "160",
      priceCurrency: "GBP",
      price: "51.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Birmingham. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "BHX-MG-005",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "152",
      priceCurrency: "GBP",
      price: "87.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Birmingham. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "BHX-PR-006",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "188",
      priceCurrency: "GBP",
      price: "56.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Birmingham. Professional chauffeurs park your car in a premium secure zone near the terminal.",
      brand: "Airport Parking Deals",
      sku: "BHX-MG-007",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "115",
      priceCurrency: "GBP",
      price: "110.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Birmingham. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "BHX-PR-008",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "137",
      priceCurrency: "GBP",
      price: "41.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Birmingham. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "BHX-MG-009",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "129",
      priceCurrency: "GBP",
      price: "79.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Birmingham Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/birmingham-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Birmingham. Secure compound just 10 minutes from the terminal.",
      brand: "Airport Parking Deals",
      sku: "BHX-PR-010",
      url: "https://www.airportparkingdeals.co.uk/birmingham-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "113",
      priceCurrency: "GBP",
      price: "37.99",
      availability: "https://schema.org/InStock"
    }
  ],
  bristol: [
    {
      type: "Product",
      name: "Bristol Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Bristol Airport. Drop your car at the terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "BRS-MG-001",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "185",
      priceCurrency: "GBP",
      price: "79.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Bristol with 24/7 security and CCTV. Shuttle transfers to the terminal included in the price.",
      brand: "Airport Parking Deals",
      sku: "BRS-PR-002",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "158",
      priceCurrency: "GBP",
      price: "43.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Bristol. Drop off right outside the terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "BRS-MG-003",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "175",
      priceCurrency: "GBP",
      price: "69.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Bristol travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "BRS-PR-004",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "145",
      priceCurrency: "GBP",
      price: "48.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Bristol. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "BRS-MG-005",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "137",
      priceCurrency: "GBP",
      price: "82.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Bristol. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "BRS-PR-006",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "168",
      priceCurrency: "GBP",
      price: "53.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Bristol. Professional chauffeurs park your car in a premium secure zone near the terminal.",
      brand: "Airport Parking Deals",
      sku: "BRS-MG-007",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "105",
      priceCurrency: "GBP",
      price: "105.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Bristol. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "BRS-PR-008",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "127",
      priceCurrency: "GBP",
      price: "39.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Bristol. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "BRS-MG-009",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "119",
      priceCurrency: "GBP",
      price: "74.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Bristol Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/bristol-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Bristol. Secure compound just 10 minutes from the terminal.",
      brand: "Airport Parking Deals",
      sku: "BRS-PR-010",
      url: "https://www.airportparkingdeals.co.uk/bristol-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "103",
      priceCurrency: "GBP",
      price: "36.99",
      availability: "https://schema.org/InStock"
    }
  ],
  stansted: [
    {
      type: "Product",
      name: "Stansted Meet and Greet Parking - Premium Service",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-meet-and-greet-premium.jpg",
      description: "Premium Meet and Greet parking at Stansted Airport. Drop your car at the terminal and a professional chauffeur parks it securely for you.",
      brand: "Airport Parking Deals",
      sku: "STN-MG-001",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "210",
      priceCurrency: "GBP",
      price: "84.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Park and Ride - Budget Saver",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-park-and-ride-budget.jpg",
      description: "Affordable Park and Ride parking at Stansted with 24/7 security and CCTV. Shuttle transfers to the terminal included in the price.",
      brand: "Airport Parking Deals",
      sku: "STN-PR-002",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "183",
      priceCurrency: "GBP",
      price: "45.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Meet and Greet - Valet Express",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-valet-express.jpg",
      description: "Quick and convenient valet-style Meet and Greet parking at Stansted. Drop off right outside the terminal with fast vehicle return on arrival.",
      brand: "Airport Parking Deals",
      sku: "STN-MG-003",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "200",
      priceCurrency: "GBP",
      price: "74.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Park and Ride - Long Stay Plus",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-park-and-ride-longstay.jpg",
      description: "Secure long-stay Park and Ride parking for Stansted travellers. Great value for trips over 7 days with frequent transfers every 15 minutes.",
      brand: "Airport Parking Deals",
      sku: "STN-PR-004",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "165",
      priceCurrency: "GBP",
      price: "50.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Meet and Greet - Family Friendly",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-meet-and-greet-family.jpg",
      description: "Hassle-free Meet and Greet parking designed for families with kids or extra luggage at Stansted. Skip the shuttle and start your holiday sooner.",
      brand: "Airport Parking Deals",
      sku: "STN-MG-005",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.9",
      reviewCount: "157",
      priceCurrency: "GBP",
      price: "87.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Park and Ride - Secure Compound",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-secure-compound.jpg",
      description: "Secure Park and Ride service with Park Mark accreditation at Stansted. 24-hour security, ANPR gates, and full CCTV coverage for peace of mind.",
      brand: "Airport Parking Deals",
      sku: "STN-PR-006",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.8",
      reviewCount: "193",
      priceCurrency: "GBP",
      price: "55.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Meet and Greet - Executive Valet",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-executive-valet.jpg",
      description: "Exclusive executive valet parking with car wash included at Stansted. Professional chauffeurs park your car in a premium secure zone near the terminal.",
      brand: "Airport Parking Deals",
      sku: "STN-MG-007",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "5.0",
      reviewCount: "118",
      priceCurrency: "GBP",
      price: "110.00",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Park and Ride - Early Bird Saver",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-earlybird-saver.jpg",
      description: "Best value Park and Ride deal for early bookings at Stansted. Discounted rates for travellers who book parking 30+ days in advance.",
      brand: "Airport Parking Deals",
      sku: "STN-PR-008",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.7",
      reviewCount: "140",
      priceCurrency: "GBP",
      price: "40.99",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Meet and Greet - Overnight Special",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-overnight-special.jpg",
      description: "Ideal for late-night or early-morning flights at Stansted. Drop off and pick up anytime with 24/7 valet support and fast return service.",
      brand: "Airport Parking Deals",
      sku: "STN-MG-009",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Meet and Greet Parking",
      ratingValue: "4.8",
      reviewCount: "132",
      priceCurrency: "GBP",
      price: "79.50",
      availability: "https://schema.org/InStock"
    },
    {
      type: "Product",
      name: "Stansted Park and Ride - Short Stay Saver",
      image: "https://www.airportparkingdeals.co.uk/images/stansted-shortstay.jpg",
      description: "Short-stay Park and Ride ideal for weekend or 3-day trips from Stansted. Secure compound just 10 minutes from the terminal.",
      brand: "Airport Parking Deals",
      sku: "STN-PR-010",
      url: "https://www.airportparkingdeals.co.uk/stansted-airport-parking",
      category: "Park and Ride Parking",
      ratingValue: "4.6",
      reviewCount: "116",
      priceCurrency: "GBP",
      price: "36.99",
      availability: "https://schema.org/InStock"
    }
  ]
};

